import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/issue';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_AUTH_USER';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/Conta~1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/64140abf-a785-40f8-9373-6696a2e493e2?version=31e883dd-84e8-407a-90c4-ad308b3d84cc&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '45',
    message: 'Parametros de entrada insuficientes.',
    bussinessErrorVariant: 'wrongParams',
  },
  {
    code: '46',
    message: 'Não foi possível localizar o membro.',
    bussinessErrorVariant: 'userNotFound',
  },
  {
    code: '57',
    message: 'Nao foi possivel criar a solicitação de alteração cadastral.',
    bussinessErrorVariant: 'errorService',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
